import { Button, Card, Checkbox, Form, Image, Input } from 'antd';
import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './Login.css';
import LoginIcon from '../../../assets/images/bookingimages/SignupIcon.png';
// import GoogleIcon from '../../../assets/images/bookingimages/google.png';
import { useNavigate } from 'react-router-dom';
import useLogin from '../../../hooks/common/uselogin';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import GoogleAuthButton from '../../GoogleAuthButton/GoogleAuthButton';

const Login = () => {
  const { onFinish, onFinishFailed } = useLogin();
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);

  const validateEmail = (_, value) => {
    if (!value) return Promise.resolve();
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value) 
        ? Promise.resolve() 
        : Promise.reject(new Error('Please enter a valid email address.'));
};

  // const validatePassword = (_, value) => {
  //   if (!value || value.length >= 8) {
  //     return Promise.resolve();
  //   }

  //   return Promise.reject(new Error('Password must be at least 8 characters long.'));
  // };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleGoogleLogin = (user) => {
    console.log("Logged in User:", user);
  };

  return (
    <Container fluid>
      <Row className='align-items-center justify-content-center py-5'>
        <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={12}>
          <Card className='p-3' style={{ borderRadius: '16px' }}>
            <Row className='d-flex align-items-center justify-content-center pt-3'>
              <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='text-center'>
                <Image
                  src={LoginIcon}
                  alt="Login"
                  preview={false}
                  style={{ width: '88px', height: '88px' }}
                />
                <h2 className='fs-24 fw-700 text-black'>Login</h2>
                <p className='fs-16 fw-400' style={{ color: '#60616C' }}>
                  Do not have an account,
                  <span
                    className='fs-16 fw-600 text-black'
                    style={{ cursor: 'pointer', textDecoration: 'underline' }}
                    onClick={() => navigate('/signup')}
                  >
                    Create a new one
                  </span>
                </p>

                <div className='google-login-btn'>
                  <GoogleAuthButton onSuccess={handleGoogleLogin} />
                </div>

                <div className="d-flex align-items-center justify-content-center py-2" style={{ position: 'relative', margin: '20px 0' }}>
                  <hr style={{ width: '45%', borderTop: '1px solid #E2E4E9', margin: '0 20px' }} />
                  <span style={{ position: 'absolute', backgroundColor: '#fff' }}>OR</span>
                  <hr style={{ width: '45%', borderTop: '1px solid #E2E4E9', margin: '0 20px' }} />
                </div>
              </Col>
            </Row>

            <Row className='d-flex align-items-center justify-content-center'>
              <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='text-center'>
                <Form
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                >

                  <Form.Item
                    name="email"
                    rules={[{ validator: validateEmail }]}
                    style={{ marginBottom: '2rem' }}
                  >
                    <div>
                      <Input
                        className="floating-input fs-14 fw-400"
                        placeholder="Email"
                        style={{ border: '1px solid #303136' }}
                      />
                      <label className="floating-label fs-12">Email</label>
                    </div>
                  </Form.Item>

                  <Form.Item
                    name="password"
                    rules={[{ required: true, message: 'Please input your password!' }]}
                    style={{ marginBottom: '2rem' }}
                  >
                    <div>
                      <Input
                        className="floating-input fs-14 fw-400"
                        type={passwordVisible ? "text" : "password"}
                        placeholder="Password"
                        style={{ border: '1px solid #303136' }}
                        suffix={
                          <span onClick={togglePasswordVisibility} style={{ cursor: 'pointer' }}>
                            {passwordVisible ? <EyeTwoTone /> : <EyeInvisibleOutlined />}
                          </span>
                        }
                      />
                      <label className="floating-label fs-12">Password</label>
                    </div>
                  </Form.Item>

                  <Row className="justify-content-between pb-4">
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={12} >
                      <Form.Item
                        valuePropName="checked"
                        style={{ textAlign: 'left', marginBottom: 0 }}
                      >
                        <Checkbox> 
                          <span className='fs-14 fw-400 text-black px-2'>Keep me logged in</span>
                        </Checkbox>
                      </Form.Item>
                    </Col>

                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={12} className="text-end">
                      <span
                        className='fs-16 fw-600 text-black'
                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                        onClick={() => navigate('/forgot-password')}
                      >
                        Forgot Password?
                      </span>
                    </Col>
                  </Row>

                  <Button
                    type="primary"
                    size='large'
                    htmlType="submit"
                    className='booking-btn fs-16 fw-700'
                    style={{
                      borderRadius: '28px',
                      padding: '24px',
                      width: '100%',
                    }}
                  >
                    Login
                  </Button>
                </Form>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
